<script lang="ts">
  import moment from 'moment';
  import { onDestroy, onMount } from 'svelte';
  import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    LineController,
    BarController,
  } from 'chart.js';
  import Table from '../Table.svelte';
  import { Chart } from 'svelte-chartjs';
  import zoomPlugin from 'chartjs-plugin-zoom';
  import DateRange from '../common/DateRange.svelte';
  import { options } from '../../configs/BarOptions';
  import { colors, resetChart } from '../../utils/common';
  import loader from 'src/components/cabinet/#assets/loader.svg';
  import { getTransactionsAnalytics } from '../../../#services/transactionsAnalytics';

  export let isPreview = false;

  let chart;
  let table;
  
  let labels = [];
  let datasets = [];

  let data = { labels, datasets };

  let startDate = 'startDate'
  let endDate = 'endDate'

  const minDate = '2023-02-20';
  const maxDate = moment().format('YYYY-MM-DD');

  ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    zoomPlugin,
  );

  function refresh() {
    resetChart(chart, labels, datasets);

    const requestData = {
      branches: [
        {
          reasonsLabel: 'Volume, USDT',
          reasons: 'itemPurchase',
          currency: 'USDT',
        },
        {
          reasonsLabel: 'Fee, USDT',
          reasons: 'itemSale',
          userId: 'realis_company',
          currency: 'USDT',
        }
      ],
      startDate: startDate && startDate !== 'startDate' ? startDate : minDate,
      endDate: endDate && endDate !== 'endDate' ? endDate : maxDate,
    };

    getTransactionsAnalytics.send({ data: requestData });
  }

  getTransactionsAnalytics.subscribe((value) => {
    if (value.hasValue && !value.error && !value.loading) {
      value.value.branches[0].values.forEach(e => {
        labels.push(e.point);
      });

      let idx = 0;
      for (const branch of value.value.branches) {
        const data = [];

        branch.values.forEach(e => {
          data.push(Math.abs(e.amount));
        });
    
        datasets.push({
          label: branch.reasonsLabel,
          backgroundColor: colors[idx],
          borderColor: colors[idx],
          fill: false,
          data,
          stack: 0
        });

        idx++;
      }

      try {
        table = {
          'Volume, USDT': value.value.branches[0]?.values.map((e) => ({ amount: Math.abs(e.amount), point: e.point })),
          'Fee, USDT': value.value.branches[1]?.values.map((e) => ({ amount: Math.abs(e.amount), point: e.point })),
          'Quantity, N': value.value.branches[0]?.values.map((e) => ({ amount: +e.count, point: e.point }))
        };
      } catch (e) {}
    }
  });

  onDestroy(() => {
    resetChart(chart);
    getTransactionsAnalytics.reset();
  });

  onMount(() => {
    refresh();
  });
</script>

{#if !isPreview}

<div class="buttons">
  <DateRange bind:startDate={startDate} bind:endDate={endDate} {minDate} {maxDate} refreshCallback={() => refresh()} />
</div>
<hr>
<div class="buttons">
  <div class="pc-line">
    <button class="btn btn-primary btn-filter" on:click={refresh}>Refresh</button>
  </div>
</div>
<p class="description">Analytics of marketplace. Info about transactions and fees.</p>
{/if}
<div class="graphic">
  {#if $getTransactionsAnalytics.error}
    {$getTransactionsAnalytics.error}
  {:else if $getTransactionsAnalytics.loading}
    <div class="graphic-loading">
      <img src="{loader}" alt="">
    </div>
  {:else if $getTransactionsAnalytics.value}
    <Chart bind:this={chart} type="bar" {data} width={500} height={270} {options} />
    {#if !isPreview}
      <Table branches={table} isTableHidden={false} />
    {/if}
  {/if}
</div>